import React from 'react';
import { Link } from 'react-router-dom';

const Header: React.FC = () => {
  return (
    <header
      className="bg-[var(--bg-surface)]/80 backdrop-blur-xl border-b border-[var(--border-default)] sticky top-0 z-30"
      style={{ paddingTop: 'env(safe-area-inset-top, 0px)' }}
    >
      <div className="flex items-center justify-center h-11 px-4">
        <Link to="/" className="flex items-center gap-2">
          <div className="w-7 h-7 rounded-lg bg-accent-600 flex items-center justify-center">
            <span className="text-white text-xs font-bold">S</span>
          </div>
          <span className="text-[15px] font-semibold text-[var(--text-primary)]">
            Stadsauktion
          </span>
        </Link>
      </div>
    </header>
  );
};

export default Header;
